import { gsap } from 'gsap';

const selector = (is, dones) => {
  return {
    //* 动画（离场前）
    "before-leave": () => {
      var _a;
      return (_a = dones == null ? void 0 : dones.beforeLeave) == null ? void 0 : _a.call(dones);
    },
    //* 动画（入场前）
    "before-enter": (el) => {
      var _a;
      (_a = dones == null ? void 0 : dones.beforeEnter) == null ? void 0 : _a.call(dones);
      is && gsap.set(el, { scaleY: 0.4, opacity: 0 });
    },
    //* 动画（离场）
    "leave": (el, done) => {
      var _a;
      if (!is) {
        (_a = dones == null ? void 0 : dones.afterLeave) == null ? void 0 : _a.call(dones);
        done == null ? void 0 : done();
      } else {
        gsap.to(el, {
          scaleY: 0.4,
          opacity: 0,
          duration: 0.2,
          onComplete: () => {
            var _a2;
            (_a2 = dones == null ? void 0 : dones.afterLeave) == null ? void 0 : _a2.call(dones);
            done == null ? void 0 : done();
          }
        });
      }
    },
    //* 动画（入场）
    "enter": (el, done) => {
      var _a;
      if (!is) {
        (_a = dones == null ? void 0 : dones.afterEnter) == null ? void 0 : _a.call(dones);
        done == null ? void 0 : done();
      } else {
        gsap.to(el, {
          scaleY: 1,
          opacity: 1,
          duration: 0.2,
          onComplete: () => {
            var _a2;
            (_a2 = dones == null ? void 0 : dones.afterEnter) == null ? void 0 : _a2.call(dones);
            done == null ? void 0 : done();
          }
        });
      }
    }
  };
};
const tooltip = (dones) => {
  return {
    //* 动画（离场前）
    "before-leave": () => {
      var _a;
      return (_a = dones == null ? void 0 : dones.beforeLeave) == null ? void 0 : _a.call(dones);
    },
    //* 动画（入场前）
    "before-enter": (el) => {
      var _a;
      (_a = dones == null ? void 0 : dones.beforeEnter) == null ? void 0 : _a.call(dones);
      gsap.set(el, { opacity: 0 });
    },
    //* 动画（离场）
    "leave": (el, done) => {
      gsap.to(el, {
        duration: 0.2,
        opacity: 0,
        onComplete: () => {
          var _a;
          (_a = dones == null ? void 0 : dones.afterLeave) == null ? void 0 : _a.call(dones);
          done == null ? void 0 : done();
        }
      });
    },
    //* 动画（入场）
    "enter": (el, done) => {
      gsap.to(el, {
        duration: 0.2,
        opacity: 1,
        onComplete: () => {
          var _a;
          (_a = dones == null ? void 0 : dones.afterEnter) == null ? void 0 : _a.call(dones);
          done == null ? void 0 : done();
        }
      });
    }
  };
};

export { selector, tooltip };
//# sourceMappingURL=index.mjs.map
